/* =========================================================
   BRHM TESTIMONIAL SLIDER
   Infinite Loop + Autoplay + Arrows + Dots + Swipe
========================================================= */

(function () {

  'use strict';


  /* =========================================================
     INITIALIZE SINGLE TESTIMONIAL SECTION
  ========================================================= */

  function initTestimonialSection(section) {

    if (!section) return;


    /* Prevent duplicate initialization */

    if (section.dataset.testimonialInitialized === 'true') {
      return;
    }

    section.dataset.testimonialInitialized = 'true';


    /* =====================================================
       ELEMENTS
    ===================================================== */

    const viewport = section.querySelector(
      '.brhm-testimonials__viewport'
    );

    const track = section.querySelector(
      '.brhm-testimonials__track'
    );

    const prevButton = section.querySelector(
      '.brhm-testimonials__arrow--prev'
    );

    const nextButton = section.querySelector(
      '.brhm-testimonials__arrow--next'
    );

    const dotsContainer = section.querySelector(
      '.brhm-testimonials__dots'
    );


    if (!viewport || !track) {
      console.warn(
        'BRHM Testimonials: viewport or track not found.'
      );

      return;
    }


    /* =====================================================
       ORIGINAL SLIDES
    ===================================================== */

    let originalSlides = Array.from(
      track.querySelectorAll(
        '.brhm-testimonials__slide:not(.is-clone)'
      )
    );


    const totalSlides = originalSlides.length;


    if (totalSlides === 0) {
      console.warn(
        'BRHM Testimonials: No slides found.'
      );

      return;
    }


    /* =====================================================
       SETTINGS
    ===================================================== */

    const autoplay =
      section.dataset.autoplay !== 'false';

    const autoplaySpeed =
      parseInt(
        section.dataset.speed,
        10
      ) || 5000;


    /* =====================================================
       STATE
    ===================================================== */

    let slidesPerView = 3;

    let currentIndex = 0;

    let isMoving = false;

    let autoplayTimer = null;

    let touchStartX = 0;

    let touchEndX = 0;


    /* =====================================================
       GET SLIDES PER VIEW
    ===================================================== */

    function getSlidesPerView() {

      if (window.innerWidth <= 767) {
        return 1;
      }

      if (window.innerWidth <= 991) {
        return 2;
      }

      return 3;

    }


    /* =====================================================
       CREATE INFINITE CLONES
    ===================================================== */

    function createClones() {

      /* Remove old clones */

      track
        .querySelectorAll(
          '.brhm-testimonials__slide.is-clone'
        )
        .forEach(function (clone) {

          clone.remove();

        });


      /* Refresh original slides */

      originalSlides = Array.from(
        track.querySelectorAll(
          '.brhm-testimonials__slide:not(.is-clone)'
        )
      );


      /*
       * Clone last slides
       */

      const beforeSlides =
        originalSlides.slice(
          -slidesPerView
        );


      beforeSlides.forEach(function (slide) {

        const clone =
          slide.cloneNode(true);

        clone.classList.add('is-clone');

        clone.setAttribute(
          'aria-hidden',
          'true'
        );

        track.insertBefore(
          clone,
          track.firstChild
        );

      });


      /*
       * Clone first slides
       */

      const afterSlides =
        originalSlides.slice(
          0,
          slidesPerView
        );


      afterSlides.forEach(function (slide) {

        const clone =
          slide.cloneNode(true);

        clone.classList.add('is-clone');

        clone.setAttribute(
          'aria-hidden',
          'true'
        );

        track.appendChild(
          clone
        );

      });


      /*
       * Start from first ORIGINAL slide
       */

      currentIndex =
        slidesPerView;

    }


    /* =====================================================
       SLIDE WIDTH
    ===================================================== */

    function getSlideWidth() {

      const slide =
        track.querySelector(
          '.brhm-testimonials__slide'
        );


      if (!slide) {
        return 0;
      }


      return slide.getBoundingClientRect().width;

    }


    /* =====================================================
       MOVE TRACK
    ===================================================== */

    function moveSlider(animate) {

      const slideWidth =
        getSlideWidth();


      if (!slideWidth) {
        return;
      }


      if (animate) {

        track.style.transition =
          'transform 0.7s cubic-bezier(0.22, 1, 0.36, 1)';

      } else {

        track.style.transition =
          'none';

      }


      const distance =
        currentIndex * slideWidth;


      track.style.transform =
        'translate3d(-' +
        distance +
        'px, 0, 0)';

    }


    /* =====================================================
       REAL INDEX
    ===================================================== */

    function getRealIndex() {

      let index =
        currentIndex -
        slidesPerView;


      index =
        index % totalSlides;


      if (index < 0) {

        index += totalSlides;

      }


      return index;

    }


    /* =====================================================
       DOTS
    ===================================================== */

    function createDots() {

      if (!dotsContainer) {
        return;
      }


      dotsContainer.innerHTML = '';


      /*
       * If only 1 testimonial
       */

      if (totalSlides <= 1) {

        dotsContainer.style.display =
          'none';

        return;

      }


      dotsContainer.style.display =
        'flex';


      for (
        let i = 0;
        i < totalSlides;
        i++
      ) {

        const dot =
          document.createElement('button');


        dot.type =
          'button';


        dot.className =
          'brhm-testimonials__dot';


        dot.dataset.index =
          i;


        dot.setAttribute(
          'aria-label',
          'Go to testimonial ' + (i + 1)
        );


        dot.addEventListener(
          'click',
          function () {

            const index =
              parseInt(
                this.dataset.index,
                10
              );


            goToSlide(index);

            restartAutoplay();

          }
        );


        dotsContainer.appendChild(
          dot
        );

      }


      updateDots();

    }


    /* =====================================================
       UPDATE DOTS
    ===================================================== */

    function updateDots() {

      if (!dotsContainer) {
        return;
      }


      const dots =
        dotsContainer.querySelectorAll(
          '.brhm-testimonials__dot'
        );


      const activeIndex =
        getRealIndex();


      dots.forEach(
        function (dot, index) {

          dot.classList.toggle(
            'is-active',
            index === activeIndex
          );

        }
      );

    }


    /* =====================================================
       GO TO SPECIFIC SLIDE
    ===================================================== */

    function goToSlide(index) {

      if (isMoving) {
        return;
      }


      currentIndex =
        slidesPerView + index;


      isMoving = true;


      moveSlider(true);

      updateDots();

    }


    /* =====================================================
       NEXT
    ===================================================== */

    function nextSlide() {

      if (isMoving) {
        return;
      }


      currentIndex++;


      isMoving = true;


      moveSlider(true);

      updateDots();

    }


    /* =====================================================
       PREVIOUS
    ===================================================== */

    function previousSlide() {

      if (isMoving) {
        return;
      }


      currentIndex--;


      isMoving = true;


      moveSlider(true);

      updateDots();

    }


    /* =====================================================
       INFINITE LOOP
    ===================================================== */

    track.addEventListener(
      'transitionend',
      function (event) {

        if (
          event.propertyName !== 'transform'
        ) {
          return;
        }


        /*
         * Reached END clones
         */

        if (
          currentIndex >=
          totalSlides + slidesPerView
        ) {

          currentIndex =
            currentIndex -
            totalSlides;


          moveSlider(false);

        }


        /*
         * Reached START clones
         */

        else if (
          currentIndex < slidesPerView
        ) {

          currentIndex =
            currentIndex +
            totalSlides;


          moveSlider(false);

        }


        isMoving = false;

        updateDots();

      }
    );


    /* =====================================================
       NEXT BUTTON
    ===================================================== */

    if (nextButton) {

      nextButton.addEventListener(
        'click',
        function () {

          nextSlide();

          restartAutoplay();

        }
      );

    }


    /* =====================================================
       PREVIOUS BUTTON
    ===================================================== */

    if (prevButton) {

      prevButton.addEventListener(
        'click',
        function () {

          previousSlide();

          restartAutoplay();

        }
      );

    }


    /* =====================================================
       AUTOPLAY
    ===================================================== */

    function startAutoplay() {

      if (
        !autoplay ||
        totalSlides <= slidesPerView
      ) {

        return;

      }


      stopAutoplay();


      autoplayTimer =
        setInterval(
          function () {

            nextSlide();

          },
          autoplaySpeed
        );

    }


    function stopAutoplay() {

      if (autoplayTimer) {

        clearInterval(
          autoplayTimer
        );

        autoplayTimer = null;

      }

    }


    function restartAutoplay() {

      stopAutoplay();

      startAutoplay();

    }


    /* =====================================================
       PAUSE ON HOVER
    ===================================================== */

    section.addEventListener(
      'mouseenter',
      function () {

        stopAutoplay();

      }
    );


    section.addEventListener(
      'mouseleave',
      function () {

        startAutoplay();

      }
    );


    /* =====================================================
       TOUCH SWIPE
    ===================================================== */

    viewport.addEventListener(
      'touchstart',
      function (event) {

        touchStartX =
          event.touches[0].clientX;

        stopAutoplay();

      },
      {
        passive: true
      }
    );


    viewport.addEventListener(
      'touchend',
      function (event) {

        touchEndX =
          event.changedTouches[0].clientX;


        const difference =
          touchStartX -
          touchEndX;


        if (
          Math.abs(difference) > 50
        ) {

          if (difference > 0) {

            nextSlide();

          } else {

            previousSlide();

          }

        }


        startAutoplay();

      },
      {
        passive: true
      }
    );


    /* =====================================================
       INITIAL SETUP
    ===================================================== */

    slidesPerView =
      getSlidesPerView();


    createClones();

    createDots();

    /*
     * First position without animation
     */

    requestAnimationFrame(
      function () {

        moveSlider(false);

      }
    );


    startAutoplay();


    /* =====================================================
       RESIZE
    ===================================================== */

    let resizeTimer;


    window.addEventListener(
      'resize',
      function () {

        clearTimeout(
          resizeTimer
        );


        resizeTimer =
          setTimeout(
            function () {

              slidesPerView =
                getSlidesPerView();


              createClones();


              createDots();


              moveSlider(false);


              isMoving = false;

            },
            250
          );

      }
    );

  }


  /* =========================================================
     INITIALIZE ALL TESTIMONIAL SECTIONS
  ========================================================= */

  function initTestimonials() {

    document
      .querySelectorAll(
        '[data-brhm-testimonials]'
      )
      .forEach(
        function (section) {

          initTestimonialSection(
            section
          );

        }
      );

  }


  /* =========================================================
     DOM READY
  ========================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initTestimonials
    );

  } else {

    initTestimonials();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          '[data-brhm-testimonials]'
        );


      if (section) {

        initTestimonialSection(
          section
        );

      }

    }
  );


})();